import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './chart.types';
import * as constants from './chart.constants';

export const chartReducer = generateResourceReducer<types.IChart>({
  STORE: constants.STORE_CHART,
  CLEAR: constants.CLEAR_CHART,
});
